import Skeleton from "../../../components/Skeleton/Skeleton";
import useScreenSize from "../../../hooks/useScreenSize";

const PageSkeleton = () => {
  const { isMobile } = useScreenSize();

  if (!isMobile) return <></>;

  return (
    <div className="flex flex-col">
      <Skeleton width="100%" height="40px" />
      <div className="flex flex-col gap-4 mt-7">
        <Skeleton width="100%" height="64px" />
        <Skeleton width="100%" height="64px" />
        <Skeleton width="100%" height="64px" />
      </div>
    </div>
  );
};

export default PageSkeleton;
